export default {
    originLenders: state => state.originLenders,
    excludeLenderIds: state => state.info.excludeLenderIds,
    useExternalUrl: state => state.info.useExternalUrl,
    totalLendersCount: state => state.info.totalLendersCount,
    customLenders: state => state.info.customLenders,
    autoSort: state => state.info.autoSort,
    pageNum: state => state.info.pageNum,
    allTotal: state => state.info.allTotal,
    searchResults: state => state.searchResults
};
